import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { SurveyResponse } from "src/app/shared/models/survey.model";

@Component({
	selector: "app-customer-survey-dashboard",
	templateUrl: "./customer-survey-dashboard.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSurveyDashboardComponent implements OnInit {
	averageResponseTime: number = 0;
	giftCardTotal: number = 0;

	surveyResponseSubscription: Subscription;

	constructor(public app: AppService, public venueService: OOVenueService, public surveyService: SurveyService) {}

	ngOnInit(): void {
		this.surveyResponseSubscription = this.surveyService.surveyResponseList.subscribe((surveyList) => {
			this.calculateResponseTime(surveyList);
			this.calculateGiftCardTotal(surveyList);
		});

		this.calculateResponseTime(this.surveyService.surveyResponseList.value);
		this.calculateGiftCardTotal(this.surveyService.surveyResponseList.value);
	}

	calculateResponseTime(surveyList: SurveyResponse[]) {
		let totalResponseTime = 0;
		if (surveyList.length > 0) {
			surveyList.forEach((survey) => {
				totalResponseTime += this.app.moment(survey.created).diff(this.app.moment(survey.check.updated), "minutes");
			});
		}
		this.averageResponseTime = totalResponseTime / surveyList.length;
	}

	calculateGiftCardTotal(surveyList: SurveyResponse[]) {
		surveyList.forEach((survey) => {
			this.giftCardTotal += +survey.survey.surveyGiftCardValue;
		});
	}
}
